// extracted by mini-css-extract-plugin
export default {"container":"editableTextArea_container__qHx1n","input":"editableTextArea_input__Anux+","count":"editableTextArea_count__Rl5Zu","text":"editableTextArea_text__iUZVo"};